import renderer from "_src/engine/renderer";
import Scene from "_src/engine/scene";

export default class Pass {

  constructor(attachmentsStorage) {

    this.attachmentsStorage = attachmentsStorage;

    this.scenes  = [];

    this.enabled = false;

  }

  init() {}

  enable() {
    this.enabled = true;
  }

  render(skipChunkTests) {

    for (let i = 0; i < this.scenes.length; ++i) {

      const scene = this.scenes[i];

      if (scene.getEnabled()) {
        renderer.renderScene(scene, skipChunkTests);
      }

    }

  }

  readPixels(sceneNumber, viewport) {

    const scene = this.scenes[sceneNumber];

    return scene.getBufferPixels(viewport);

  }

  getColorAttachment(number) {

    const scene = this.getMainScene();
    const frameBuffer = scene.getFramebuffer();

    if (!frameBuffer) {
      return null;
    }

    const colorAttachments = frameBuffer.colorAttachments;

    return colorAttachments ? colorAttachments[number] : null;

  }

  getDepthAttachment() {

    const scene = this.getMainScene();
    const frameBuffer = scene.getFramebuffer();

    if (!frameBuffer) {
      return null;
    }

    return frameBuffer.depthAttachment;

  }

  getScreenQuad(scene) {
    return scene._children[0];
  }

  getScenes() {
    return this.scenes;
  }

  getMainScene() {
    return this.scenes[0];
  }

  getSecondScene() {
    return this.scenes[1];
  }

  getLastScene() {
    return this.scenes[this.scenes.length - 1];
  }

  _addScene(camera) {

    const scene = new Scene();
    scene.appendCamera(camera);
    this.scenes.push(scene);

    return scene;

  }

  getOutputBody() {

    const scene = this.getLastScene();
    return scene.getFramebuffer();

  }

  resize(width, height) {
    for (let scene of this.scenes) {
      scene.resize(width, height);
    }
  }

  disable() {

    for (let i = 0; i < this.scenes.length; ++i) {

      const scene = this.scenes[i];

      const resolveFrameBuffer = scene.getResolvedBuffer();
      const frameBuffer = scene.getFramebuffer();

      scene.setFramebuffer(null);
      scene.setResolvedBuffer(null);

      if (frameBuffer) {
        frameBuffer.cleanup();
      }

      if (resolveFrameBuffer) {
        resolveFrameBuffer.cleanup();
      }

    }

    this.enabled = false;

  }

  destroy() {

    for (const scene of this.scenes) {
      scene.removeChildren();
    }
    this.scenes.length = 0;

    this.attachmentsStorage = null;

  }

}
